import { Collection } from 'firestorter';
import CollectionName from '../utils/collections';
import BaseDocument from './BaseDocument';

class CoachVoice extends BaseDocument {
  constructor(id, opts) {
    super(`${CollectionName.COACH_VOICE}/${id}`, opts);
  }

  get samples() {
    return this.data?.samples || [];
  }

  get status() {
    return this.data?.status;
  }

  get createdAt() {
    return this.data?.createdAt;
  }

  get lastProcessedMessageId() {
    return this.data?.lastProcessedMessageId;
  }

  get isComplete() {
    return this.status === 'COMPLETE';
  }

  get isPending() {
    return this.status === 'PENDING';
  }

  get isErrored() {
    return this.status === 'ERRORED';
  }

  static async getCoachVoices() {
    const coachVoiceCollection = new Collection(CollectionName.COACH_VOICE, {
      createDocument: (source, options) => new CoachVoice(source.id, options),
    });

    await CoachVoice.initCollection(coachVoiceCollection);

    return coachVoiceCollection;
  }
}

export default CoachVoice;
